import { render, staticRenderFns } from "./HallSection.vue?vue&type=template&id=5d1da2f6&scoped=true&"
import script from "./HallSection.vue?vue&type=script&lang=js&"
export * from "./HallSection.vue?vue&type=script&lang=js&"
import style0 from "./HallSection.vue?vue&type=style&index=0&id=5d1da2f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1da2f6",
  null
  
)

export default component.exports